export const DEVICE_PIXEL_THRESHOLD = 1024;
export const DEFAULT_DESKTOP_GRID_COLUMNS = "repeat(4, 1fr)";
